import DatabaseAdvancedView from './DatabaseAdvancedView'

export default DatabaseAdvancedView
